import useSWR, { SWRConfiguration } from "swr";
import {
  getOrderSheetRevisionV2Key,
  GetOrderSheetRevisionV2PathParameter,
  GetOrderSheetRevisionV2Request,
} from "./use-get-order-sheet-revision-v2";
import useListAllSheetTabsAndRevisionV2Fetcher
  from "@/features/line-sheet-sets/hooks/use-list-all-sheet-tabs-revision-fetcher-v2";

export default function useGetListOrderSheetTabsWithRevision(
  parameter: GetOrderSheetRevisionV2PathParameter,
  request: GetOrderSheetRevisionV2Request,
  config: SWRConfiguration = {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  }
) {
  const fetcher = useListAllSheetTabsAndRevisionV2Fetcher();
  return useSWR(getOrderSheetRevisionV2Key(parameter, request), fetcher, config);
}
